import { useEffect, useState } from "react";
import { _AdquisitionItemCDP, _BudgetRPFactory, _DocumentFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Modal } from "../../theme/Component/Modal";
import { BasicButton } from "../../theme/Component/BasicButton";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { PrintJson } from "../../theme/Component/PrintJson";
import { SelectorDocumentFactory } from "../bodegaDocumentos/SelectorDocumentFactory";

interface Props {
    value?: any;
    contrat?: any;
    label?: string;
    onChange: Function;
    renderValue?:string;
}

export const CDPsEditor = ({ contrat, label, onChange, renderValue }: Props) => {

    const _budgetRDFactory = useDataBean(_BudgetRPFactory);
    const _documents = useDataBean(_DocumentFactory);
    const _adquisitionContractCDP = useDataBean(_AdquisitionItemCDP);
    const _docFactory = useDataBean(_DocumentFactory);
    const single = Singleton.getInstance();

    const [valor, setValor] = useState<string>();
    const [mnemonic, setMnemonic] = useState<string>();
    const [year, setYear] = useState<number>(single.getCurrenYear());
    const [consecutive, setConsecutive] = useState<number>(NaN);
    const [reference, setReference] = useState<number>(NaN);

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (contrat?.IDAdquisitionContract) {
            getCDPContract();
        }
    }, [contrat])

    useEffect(()=>{
        setValor(renderValue)
    },[renderValue])

    const getItem = () => {
        if (_budgetRDFactory.bean.IDDocument) {

            setModal({ ...modal, "view": false })
            setValor(`${_budgetRDFactory.bean.IDDocument} - ${_budgetRDFactory.bean.Mnemonic} - ${_budgetRDFactory.bean.Consecutive}`);
            onChange(_budgetRDFactory.bean)
        } else {
            toast.error("CDP no valido")
        }
    }

    const getCDPConsecutive = () => {
        _budgetRDFactory.instance.getCDPByConsecutive(year, consecutive, null).then(
            (resp) => {
                _budgetRDFactory.setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const buscarDocumento = () => {
        _docFactory.instance.getDocumentsAndConsecutive(year, mnemonic, consecutive ?? null, null, null, null, reference ?? null).then(
            (resp: any) => {
                _budgetRDFactory.setLista(resp);
            }
        ).catch(err => toast.error(err));
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha', property: 'Since', visible: true, mask: MASK_DATE },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Consecutivo Externo', property: 'ExternalReference', visible: true },
        { title: 'Valor del CDP', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Valor Restante', property: 'CDPLeft', visible: true, mask: MASK_MONEY },
        { title: 'Valor de RP', property: 'RPValue', visible: true, mask: MASK_MONEY },
    ]

   
    const getCDPContract = () => {
        _adquisitionContractCDP.instance.getCDPBudgetByDocument(single.getCurrenYear(), contrat.IDAdquisitionItem).then(
            (resp) => {
                _budgetRDFactory.setLista(resp)
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }


    return (
        <>
            <label>{label ?? "Documento"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true })}>
                {valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={getItem}>
                <div className="row">
                    <div className="col-md-6">
                        <YearSelector tittle="Año" value={year} onChange={(e) => { setYear(e) }} />
                    </div>
                    {!contrat &&
                    <div className="col-md-6">
                        <SelectorDocumentFactory label="Documento" filterDocument={['CDP','RP']} onChange={(e) => { setMnemonic(e.Mnemonic)  }}  />
                    </div>
                    }
                    {!contrat?.IDAdquisitionContract &&
                        <>
                            <div className="col-md-6">
                                <label>Consecutivo</label>
                                <input type="number" className="form-control" value={consecutive} onChange={(e) => { setConsecutive(parseInt(e.target.value)) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Consecutivo Externo</label>
                                <input type="number" className="form-control" value={reference} onChange={(e) => { setReference(parseInt(e.target.value)) }} />
                            </div>
                            <div className="col-md-2 mt-4">
                                <BasicButton eventClick={buscarDocumento} icon="ri-search-line">Buscar</BasicButton>
                            </div>
                        </>
                    }
                    <div className="col-md-12">
                        <BasicTable body={_budgetRDFactory.lista} head={head} rowSet={_budgetRDFactory.setBean} />
                    </div>
                </div>
            </Modal>
        </>
    )
}